import { Button, Tooltip, message } from 'antd';
import { ColumnsType } from 'antd/lib/table';
import { BankMasterFormPayloadType } from 'api/nach';
import { Link } from 'react-router-dom';
import { NACH_ROUTE } from '../routes';

const deleteHandler = () => {
  const confirm = window.confirm('Are you sure to delete?');
  if (!confirm) {
    return;
  }
  message.success('Deleted Successfully');
  console.log('deleteHandler');
};

export const BankMasterColumnsFields: ColumnsType<BankMasterFormPayloadType> = [
  {
    key: 'BankId',
    title: 'Bank ID',
    dataIndex: 'BankId',
    fixed: 'left',
    ellipsis: true,
    render: (record) => (
      <>
        <Tooltip placement="topLeft" title={record}>
          <span style={{ fontWeight: '600', fontSize: '16px' }}>{record}</span>
        </Tooltip>

        {/* <Link to="/nach/bank_master/update" state={record}>
            {_}
          </Link> */}
      </>
    ),
  },

  {
    key: 'BankName',
    title: 'Bank Name',
    dataIndex: 'BankName',
    ellipsis: true,
    render: (record) => (
      <Tooltip placement="topLeft" title={record}>
        {record}
      </Tooltip>
    ),
  },

  {
    key: 'NachType',
    title: 'NACH Type',
    dataIndex: 'NachType',
    ellipsis: true,
    render: (record) => (
      <Tooltip placement="topLeft" title={record}>
        {record}
      </Tooltip>
    ),
  },

  {
    key: 'Status',
    title: 'Status',
    dataIndex: 'Status',
    ellipsis: true,
    render: (record) => (
      <Tooltip placement="topLeft" title={record}>
        {record}
      </Tooltip>
    ),
  },
  {
    key: 'Action',
    title: 'Action',
    dataIndex: 'Action',
    render: (_, record) => (
      <span
        style={{
          display: 'flex',
          gap: '4px',
        }}
      >
        <Button type="primary" style={{ flex: '1' }}>
          <Link to={NACH_ROUTE.bank_master_update.to} state={record}>
            Edit
          </Link>
        </Button>
        <Button type="primary" onClick={deleteHandler} style={{ flex: '1' }}>
          Delete
        </Button>
      </span>
    ),
  },
];
